module.exports = __webpack_public_path__ + "img/video-pitch-icon.860f4332.svg";